$(function() {
  $('.sizeguide_toggler, .sizeguide_wrapper--close').click(() => {
      if ($('.sizeguide_wrapper').is(':visible')) {
        $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      } else {
        $('.sizeguide_wrapper').show();

        // On mobile, prevent body from scrolling when popup is open
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'hidden');
        }
      }
  });
  
  // Scrolling the window will close the popup
  $(window).scroll(() => {
      if ( window.innerWidth > 768 && $('.sizeguide_wrapper').is(':visible') ) {
          $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      }
  });

  // Clicks outside the wrapper will close the popup
  $(document).mouseup(e => {
      if (!$('.sizeguide_wrapper').is(e.target) && $('.sizeguide_wrapper').has(e.target).length === 0) {
          $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      }
  });
  
}); // DOM Loaded